import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, UrlTree} from '@angular/router';
import {PermissionService} from './permission.service';
import {AdminPermission} from '../models/admin-permissions';

@Injectable({providedIn: 'root'})
export class PermissionGuard implements CanActivate {
    constructor(private permissionService: PermissionService,
                private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const permissions = (route.data['permissions'] || []) as AdminPermission[];
        if (permissions.length === 0 || this.permissionService.hasAny(permissions)) {
            return true;
        }

        return this.router.createUrlTree(['/central/overview']);
    }
}
